import React from 'react';
import { Tooltip } from 'components/antd';
import styles from './styles.module.scss';
import { roundNumber } from 'utils/converters';
import classNames from 'classnames';

interface Props {
    rating: number;
    alignRight?: boolean;
}

const ShowRating: React.FC<Props> = ({ rating, alignRight }) => (
    <div
        className={classNames(styles.providerRating, {
            [styles.providerRatingRight]: alignRight,
        })}
    >
        <Tooltip title={`${roundNumber(rating, 1)} out of 5`} placement="bottom">
            <span className={styles.providerRatingIcon} />
        </Tooltip>
        <span className={styles.providerRatingCount}>
            {roundNumber(rating, 1)}
        </span>
    </div>
)

export default ShowRating;